<template>
  <span>
    <button class="btn btn-green addDocBtn" type="button" v-tooltip="'Add Document'" 
    @click="openFileSelection()"> <i class="fa-solid fa-2x fa-file-circle-plus"></i>
      
    </button>

    <!-- File Selection -->
    <modal title="Upload Documents - Select Files" ref="fileSelection" @save="openFileDetails()" save-text="Next" :dismiss-needed="false" :disable-save="fileListLength == 0">
      <div class="form-group upload-container">
        <input type="file" id="file_upload" class="form-control" multiple placeholder="" @change="fileSelected">
      </div>
      <label>Files</label>
      <div v-if="showFiles">
        <div class="row form-group" v-for="file in formData.values()" :key="file.name">
          <div class="col-md-7">
            <label>{{file.name}}</label>
          </div>
          <div class="col-md-5 row">
            <div class="col">
              <label>{{sizeBytesToKb(file.size)}} KB</label>
            </div>
            <div class="col" style="justify-content:right">
              <strong class="removeLabel" @click="removeFile(file.name)">Remove</strong>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- File Details -->
    <modal :title="`Documentation - File Details (` + (fileIndex+1) + `/` + fileListLength + `)`" ref="fileDetails" @save="nextDetail()" save-text="Next" :dismiss-needed="false" :disable-save="docUpload.description.length == 0 || docUpload.type.length == 0">
      <div class="form-group">
        <label>File</label>
        <div v-for="(file, index) in formData.values()" :key="file.name">
          <input class="form-control" disabled v-if="index == fileIndex" v-model="file.name" />
        </div>
      </div>
      <div class="form-group">
        <label>Type</label> &nbsp; <strong style="color: red">*</strong>
        <select class="form-control" v-model="docUpload.type">
          <option v-for="type in uploadDocumentTypes" :key="type.name" :value="type.name">{{type.description}}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Description</label> &nbsp; <strong style="color: red">*</strong>
        <input class="form-control" v-model="docUpload.description" />
      </div>
    </modal>

    <!-- Finalization -->
    <modal title="Documentation - Finalization" ref="finalization" @save="uploadDocuments()" save-text="Upload" :dismiss-needed="false" :disable-save="false">
      <div class="row form-group" v-for="(file, index) in formData.values()" :key="file.name" style="padding-top:1em; padding-bottom:1em">
        <div class="col-md-10 row">
          <div class="col-md-3">
            <label>File:</label>
          </div>
          <div class="col-md-9">
            <label>{{file.name}}</label>
          </div>
        </div>
        
        <div class="col-md-10 row" v-if="fileListDetails[index]">
          <div class="col-md-3">
            <label>Type:</label>
          </div>
          <div class="col-md-9">
            <label v-if="fileListDetails[index].type.length > 0">{{fileListDetails[index].type}}</label>
            <strong style="color: red" v-else>Missing Type</strong>
          </div>
        </div>

        <div class="col-md-10 row" v-if="fileListDetails[index]">
          <div class="col-md-3">
            <label>Description:</label>
          </div>
          <div class="col-md-9">
            <label v-if="fileListDetails[index].description.length > 0">{{fileListDetails[index].description}}</label>
            <strong style="color: red" v-else>Missing Description</strong>
          </div>
        </div>
        <div class="col-md-2" style="text-align:center">
          <strong class="removeLabel" @click="editFile(index)">Edit</strong>
        </div>
        
        <div class="col-md-10 row">
          <div class="col-md-3">
            <label>Size</label>
          </div>
          <div class="col-md-9">
              <label>{{sizeBytesToKb(file.size)}} KB</label>
          </div>
        </div>
        
      </div>
    </modal>

    <!-- Final Edit -->
    <modal :title="`Documentation - Edit Details (` + (fileIndex+1) + `/` + fileListLength + `)`" ref="finalEdit" @save="goToFinal()" save-text="Confirm" :dismiss-needed="false" :disable-save="docUpload.description.length == 0 || docUpload.type.length == 0">
      <div class="form-group">
        <label>File</label>
        <div v-for="(file, index) in formData.values()" :key="file.name">
          <input class="form-control" disabled v-if="index == fileIndex" v-model="file.name" />
        </div>
      </div>
      <div class="form-group">
        <label>Type</label> &nbsp; <strong style="color: red">*</strong>
        <select class="form-control" v-model="docUpload.type">
          <option v-for="type in uploadDocumentTypes" :key="type.name" :value="type.name">{{type.value}}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Description</label> &nbsp; <strong style="color: red">*</strong>
        <input class="form-control" v-model="docUpload.description" />
      </div>
    </modal>
  </span>
</template>

<script>
  import Modal from '@/components/GeneralComponents/Modal';
  import Popper from 'vue-popperjs';
  import 'vue-popperjs/dist/vue-popper.css';
  export default {
    props: {
      documentTypes: {
        type: Array,
        required: true
      },
      documents: {
        type: [Array, Object],
        required: true
      },
      supplierNumber: {
        type: [Number, String],
        required: true
      }
    },
    components: {
      Modal,
      'popper': Popper
    },
    data() {
      return {
        docUpload: {
          type: '',
          description: '',
          file: {}
        },
        selectAll: false,
        searchText: '',
        
        formData: new FormData(),

        selectedFiles: [],
        showFiles: true,

        fileListLength: 0,
        fileListDetails: [],
        fileIndex: 0,
      }
    },
    computed: {
      uploadDocumentTypes() {
        return this.documentTypes.filter((type) => type.name !== 'BBBEE');
      },
      allDetailsExist() {
        if (this.fileListDetails) {
          let temp = false;
          for (let i = 0; i < this.fileListLength; i++) {
            if (this.fileListDetails[i] && this.fileListDetails[i].type.length == 0) {
              temp = true;
            }
            if (this.fileListDetails[i] && this.fileListDetails[i].description.length == 0) {
              temp = true;
            }
          }
          return temp
        } else {
          return false
        }
      }
    },
    methods: {
      openFileSelection() {
        this.selectedSales = [];
        this.$refs.fileSelection.open();
      },
      openFileDetails() {
        for (let i = 0; i < this.fileListLength; i++) {
          if (!this.fileListDetails[i]) {
            this.fileListDetails.push({type: '', description: '', selectedSales: []});
          }
        }

        this.fileIndex = 0;
        this.getDetails();

        this.$refs.fileSelection.close();
        this.$refs.fileDetails.open();
      },
      nextDetail() {
        this.setDetails();
        this.fileIndex++;

        if (this.fileIndex == this.fileListLength) {
          this.openFinalization();
        } else {
          this.getDetails();

          this.$refs.fileDetails.close();
          this.$refs.fileDetails.open();
        }
      },
      goToFinal() {
        this.setDetails();
        this.fileIndex == this.fileListLength-1;

        this.$refs.finalEdit.close();
        this.$refs.finalization.open();
      },
      openFinalization() {
        this.$refs.fileDetails.close();
        this.$refs.finalization.open();
      },
      getDetails() {
        this.docUpload.type = this.fileListDetails[this.fileIndex].type;
        this.docUpload.description = this.fileListDetails[this.fileIndex].description;
        this.selectedSales = this.fileListDetails[this.fileIndex].selectedSales;
      },
      setDetails() {
        this.fileListDetails[this.fileIndex].type = this.docUpload.type;
        this.fileListDetails[this.fileIndex].description = this.docUpload.description;
        this.fileListDetails[this.fileIndex].selectedSales = this.selectedSales;
      },
      fileSelected(event) {
        this.showFiles = false;
        this.showFiles = true;

        this.selectedFiles = event.target.files;
        let largeFiles = [];

        for (let i = 0; i < this.selectedFiles.length; i++) {
          if (!this.formData.has(this.selectedFiles[i].name)) {
            if (this.selectedFiles[i].size / 1024 / 1024 < 15) {
              this.formData.append(this.selectedFiles[i].name, this.selectedFiles[i]);
              this.fileListLength++;
            } else {
              largeFiles.push(this.selectedFiles[i].name);
            }
          }
        }

        if (largeFiles.length > 0) {
          let temp = "";
          for (let i = 0; i < largeFiles.length; i++) {
            if (i == largeFiles.length - 1) {
              temp += largeFiles[i]
            } else if (i == largeFiles.length - 2) {
              temp += largeFiles[i] + " and "
            } else {
              temp += largeFiles[i] + ", "
            }
          }
          if (largeFiles.length > 1) {
            temp += ' were too large.'
          } else {
            temp += ' was too large.'
          }

          this.$swal({
            title: 'Maximum file size is 15MB',
            text: temp,
            type: 'warning',
            confirmButtonText: 'Ok'
          })
        }
      },
      editFile(data) {
        this.fileIndex = data;
        this.getDetails();

        this.$refs.finalization.close();
        this.$refs.finalEdit.open();
      },
      removeFile(data) {
        this.formData.delete(data);
        this.fileListLength--;
        this.showFiles = false;
        this.showFiles = true;
      },
      resetUpload: function () {
        this.formData = new FormData();
        this.fileListDetails = [];
        this.fileListLength = 0;
        this.fileIndex = 0;
      },
      uploadDocuments() {
        const formData = new FormData();
        let filesSelected = [];
        let fileData = [];

        for (var value of this.formData.values()) {
          filesSelected.push(value);
        }

        for (let i = 0; i < this.fileListLength; i++) {
          fileData.push({
            fileName: filesSelected[i].name, 
            type: this.fileListDetails[i].type, 
            description: this.fileListDetails[i].description
          });
        }
        
        for (var value of filesSelected.values()) {
          formData.append('files', value);
        }
        formData.append('data', JSON.stringify(fileData));

        this.$refs.fileSelection.isLoading();
        this.$http.post(this.$config.aimsAPIv3 + 'suppliers/' + this.supplierNumber + '/documents/upload',
          formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(response => {
            this.showSuccess("File Uploaded Successfully");
            this.resetUpload();

            for (let i = 0; i < response.data.length; i++) {
              response.data[i].isNew = true;
            }

            this.$emit('loadDocuments');
            this.$refs.finalization.close();
          },
          error => {
            this.resetUpload();
            console.error(error);
            this.showError('Error Uploading Documents', error);
          }).finally(() => {
            this.$refs.finalization.isLoading();
          });
      },
      sizeBytesToKb(value) {
        if (value && value > 0) {
          return (value / 1024).toFixed(2)
        } else {
          return 0;
        }
      }
    }
  }

</script>

<style>
.addDocBtn {
  padding-right: 10px;
}

.removeLabel {
  color: red;
}

.removeLabel:hover {
  cursor: pointer;
}

.upload-container {
  position: relative;
  width: 100%;
}

.upload-container input, 
.upload-container input:focus{
  border: 2px dashed #23B7E5;
  padding: 100px 0px 200px ;
  color: transparent;
  width: 100%;
  background: #f1f1f1;
  background-image: url("/img/components/drag.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.upload-container input:hover {
  background: #ddd;
  background-image: url("/img/components/drag.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.upload-container input::file-selector-button {
  display: none;
}
</style>
